import React from 'react';
import { Wsi } from '../../models/BackendModels';
import ClinicalTextEntries from './ClinicalTextEntries';
import './DiagnosisContext.css';

type Context = Pick<Wsi, 'simplifiedDiagnosis' | 'diagnosisText' | 'findingsText'> & Partial<Pick<Wsi,
    'diagnosisTextEn' | 'diagnosisTextDe' | 'findingsTextEn' | 'findingsTextDe' |
    'diagnosisSourceLanguage' | 'findingsSourceLanguage' |
    'diagnosisTranslationStatus' | 'findingsTranslationStatus'
>>;

interface Props {
    context?: Context;
}

const DiagnosisContext: React.FC<Props> = ({ context }) => {
    const diagnoses = context?.simplifiedDiagnosis?.filter((value) => value.trim());
    const diagnosisText = context?.diagnosisText;
    const findingsText = context?.findingsText;
    if (!diagnoses?.length && !diagnosisText?.trim() && !findingsText?.trim()) {
        return null;
    }

    return (
        <section className="card card-small diagnosis-context" aria-label="Image clinical context">
            <h6 className="diagnosis-context__heading">Image clinical context</h6>
            <dl className="diagnosis-context__fields" style={{ overflowWrap: 'anywhere', whiteSpace: 'pre-wrap' }}>
                {!!diagnoses?.length && (
                    <div className="diagnosis-context__field diagnosis-context__field--simplified">
                        <dt>Simplified diagnosis</dt>
                        <dd>{diagnoses.join(', ')}</dd>
                    </div>
                )}
                {!!diagnosisText?.trim() && (
                    <div className="diagnosis-context__field diagnosis-context__field--diagnosis">
                        <dt>Diagnosis text</dt>
                        <dd>
                            <ClinicalTextEntries
                                original={diagnosisText!}
                                english={context?.diagnosisTextEn}
                                german={context?.diagnosisTextDe}
                                sourceLanguage={context?.diagnosisSourceLanguage}
                                status={context?.diagnosisTranslationStatus}
                            />
                        </dd>
                    </div>
                )}
                {!!findingsText?.trim() && (
                    <div className="diagnosis-context__field diagnosis-context__field--findings">
                        <dt>Findings</dt>
                        <dd>
                            <ClinicalTextEntries
                                original={findingsText!}
                                english={context?.findingsTextEn}
                                german={context?.findingsTextDe}
                                sourceLanguage={context?.findingsSourceLanguage}
                                status={context?.findingsTranslationStatus}
                            />
                        </dd>
                    </div>
                )}
            </dl>
        </section>
    );
};

export default DiagnosisContext;
